<template>
  <v-container max-width="500px" max-height="300px">
    <v-card class="mt-2">
      <v-card-title>
        <h1 class="mr-2 grey--text">Τιμολόγιο</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
        <h3 class="mr-2 my-6  subheading grey--text">Αρ. Τιμολογίου: {{ invoice.InvoiceId }}</h3>
          </v-col>
            <v-spacer></v-spacer>
          <v-col >
          <h3 class="mr-2 my-6  subheading grey--text">Πληρωμή: {{ paym[invoice.PaymTerm] }}</h3>
          </v-col>
          <v-col >
        <h3 class="mr-2 my-6 text-right subheading grey--text">Ημερομηνία: {{ invoice.Date }}</h3>
          </v-col>
        </v-row>

	<v-data-table
		:headers="headers"
		:items="invoice.Lines"
		fixed-header
		height="300px"
		:items-per-page=5
		class="elevation-1"
		item-key="Id">
        <template v-slot:item.LineNetValue="{ item }">
            {{ tocurr(item.LineNetValue) }}
        </template>
        <template v-slot:item.LineTotalValue="{ item }">
            {{ tocurr(item.LineGross) }}
        </template>
		</v-data-table>
        <v-divider></v-divider>
        <v-card class="d-flex justify-space-around elevation-0 py-2 mt-2">
          <v-card class="elevation-0"><b>Σύνολο:</b> {{ tocurr(invoice.NetValue) }} </v-card>
          <v-card class="elevation-0"><b>ΦΠΑ 24%:</b> {{ tocurr(invoice.VatValue) }} </v-card>
          <v-card class="elevation-0"><b>Γενικό Σύνολο:</b> {{ tocurr(invoice.TotalValue) }} </v-card>
        </v-card>
      </v-card-text>

    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'InvoiceSummary',
  props: {
    invoiceId: { required: true, type: Number },
  },
  components: {
  },
  computed: {
  },
  watch: {
    async invoiceId () { await this.fetchInvoice(); },
  },
  data() {
    return {
      loading: true,
      customer: "",
      invoice: { InvoiceId: "", Lines: [] },
      paym: {
            1: "Μετρητοίς",
            3: "Πληρωμή με κάρτα",
            4: "Κατάθεση",
            5: "Επιταγή",
            6: "Αντικαταβολή",
            7: "Επί Πιστώσει"
      },
      headers: [
      { text: 'A/A', value: 'Line', sortable: false, width: '5%' },
      { text: 'Κωδικός', value: 'ItemCode', sortable: false, width: '15%' },
      { text: 'Περιγραφή', value: 'ItemDesc', sortable: false, width: '35%' },
      { text: 'Ποσότητα', value: 'Qty', sortable: false, width: '5%' },
      //{ text: 'Μονάδα', value: 'Unit', sortable: false, width: '8%' },
      { text: 'Τιμή', value: 'LineNetValue', sortable: false },
      { text: 'Αξία', value: 'LineTotalValue', sortable: true },
      ],
    };
  },
  async mounted() {
    await this.fetchInvoice();
  },
  methods: {
    afm(afmnum) {
      return new String(Number(afmnum).toFixed()).padStart(9, "0");
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    async fetchInvoice() {
      try {
        const response = await this.$api.get("invoices/" + this.invoiceId);
        this.invoice = response.data;
        // console.log(this.invoice);
        //this.lineitems = this.invoice.Lines;
        //console.log(this.lineitems);
        //this.$store.cid = this.$store.customer.Id
        //this.customer = this.invoice.Customer;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style type="text/css" media="screen">
   width: 20%;
</style>
